import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgIcon } from '@ng-icons/core';
import {
    QpxButton,
    QpxIcon,
    QpxHeroIcon,
    QpxTypography,
} from '@quipex/shared/ui';
@Component({
    selector: 'qpx-quippy-pack-review-actions',
    imports: [
        MatButtonModule,
        NgIcon,
        QpxButton,
        QpxIcon,
        QpxHeroIcon,
        QpxTypography,
    ],
    templateUrl: './review-actions.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'grid gap-4' },
})
export class QuippyPackReviewActions {
    public readonly editClicked = output<void>();
    public readonly applyClicked = output<void>();
}
